export default {
  "Select All": "Seleccioner Tout",
  "This field is required": "Ce champ est requis",
  "Add New Company": "Ajouter une nouvelle entreprise",
  "COMPANY REGISTRATION": "enregistrement de l'entreprise",
  "COMPANY INFORMATION": "Informations sur l'entreprise",
  "SUBSCRIPTION LIST": "Liste d'abonnement",
  Account: "Compte",
  "Switch to Old View": "Passer a l'ancienne vue",
  Messaging: "Messagerie",
  Logout: "Déconnexion",
  "MANAGE LOGS": "Gérer les journaux",
  Date: "Date",
  "Total Hours Worked": "Total de heures travaillees",
  "Total Distance": "Distance total",
  "Driver Name": "NOM DU CONDUCTEUR",
  "Vehicle Name": "Nom du véhicule",
  Upload: "Telecharger",
  "No file selected": "Aucun fichier selectionne",
  Cancel: "Annuler",
  Save: "Enregistrer",
  Reset: "Reinitialiser",
  "The email is not valid": "L'email n'est pas valide",
  "LOG BOOK": "Journal",
  Description: "Description",
  "Date (in UTC)": "Date (dans UTC)",
  "VIEW DOCUMENT": "Afficher le document",
  NEXT: "Suivant",
  PREV: "PRECEDENT",
  "DAILY LOG HISTORY": "Historique des journaux quotidiens",
  Actions: "Actions",
  Annotation: "Annotation",
  "Modified By": "Modifie par",
  Version: "Version",
  ELD: "ELD details de deconenecte",
  OTHER: "Autre",
  "LOG IN": "Connexion",
  REGISTRATION: "Enregistrement",
  Forgot: "Mot de passe oublié ?",
  ForgotHeading: "Nour vous aiderons a le reinitialiser et a vous remmetre sure la vonne voie",
  viewSample: "Voir un echantillon",
  "Forgot password?": "Mot de passe oublié ?",
  "Remember me": "Souvenez-vous de moi",
  backLogin: "Retour connexion",
  emailAddress: "ADRESSE E-MAIL",
  "Log in": "Connexion",
  "If your email address is registered with us, you will receive a password recovery link at your email address": {

  },
  "FDCSA info": "NB : cela enverra les fichiers à la FMCSA par e-mail ou via les services Web, comme indiqué dans l'annexe A de la sous-partie B de la partie 395.",
  "mail@gmail.com": "mail@gmail.com",
  Password: "Mot de passe",
  email: "Courriel",
  Email: "Courriel",
  "EDIT DAILY LOG": "Modifier le journal quotidien",
  "Email or Employee Id": "Email ou ID d'employe",
  "Send a Message": "Envoyer un message",
  "Select Drivers here": "Selectionnez les conductuers ici",
  "Select Drivers here...": "Selectionnez les conductuers ici",
  Type: "Type",
  Logs: "Journaux",
  Export: "Exportation",
  "Start Time": "Heure de début",
  "End Time": "Heure de fin",
  "Assigned Driver": "Conducteur assigne",
  "Co-Driver": "Copilote",
  Status: "Statut",
  PREVIOUS: "Précédent",
  "Last Name": "NOM",
  apology: "Nous excusons",
  "page moved": "Cette page a ete deplacee our suppriimee",
  "send feedback": "Veuillez nous enboyer vos commentairs",
  here: "ici",
  "First Name": "PRÉNOM",
  "Registration Date": "Date d'inscription",
  "Un authorized": "Non autorise",
  "USER INFORMATION": "Information d'utilisateur",
  selectWithDot: "Sélectionner...",
  "Cost Per Truck $": "Coût par camion $",
  Activate: "Activer",
  "Requested By": "Demandé par",
  "Date Requested": "Date de la demande",
  "Prepaid Expiration Date": "Date d'expiration du prépaiement",
  "Monthly Minimum $": "Minimum mensuel $",
  "Zoho Customer Id": "Identifiant client Zoho",
  "Additional Line Items": "Lignes supplémentaires",
  "Enable additional line items": "Activer les lignes supplémentaires",
  "Prepaid Amount": "Montant prépayé",
  "Seperate DVIR only": "Seperate DVIR only",
  "By Vehicle": "Par véhicule",
  "By Driver": "Par conducteur",
  "WL Billing Info": "Informations de facturation WL",
  commissionRate: "Taux de commission",
  goToInspections: "Retourner aux inspections",
  forgotPassword: "Forgot password ?",
  logo: "Logo",
  parentProducer: "Revendeur parent",
  policyHolder: "Titulaire de la police",
  resellerInformation: "Informations sur le revendeur",
  resellerName: "Nom du revendeur",
  resetPassword: "Réinitialisation du mot de passe",
  suspendCompany: "Suspendre la société",
  theme: "Thème",
  footer: {
    address: {
      one: "Bureau d'Entreprise",
      two: "Bureau",
      three: "En ligne",
      onedetails: "Houston, TX",
      twodetails: "844-636-1360",
      threedetails: "info@gorillasafety.com",
    },
    patent: "Brevet en instance",
    copyright: "Droits d'auteur 2020",
    PrivacyLegal: "Confidentialite et juriduque",
  },
  serviceRequest: {
    pendingMechanic: "Mécanicien en attente",
    pendingDriver: "Chauffeur en attente",
    completed: "Terminé",
    manageServiceRequest: "Gérer les demandes de service",
  },
  alerts: {
    activated: "Activation réussie !",
    deactivated: "Désactivation réussie !",
  },
  errorTexts: {
    max120Char: "Veuillez saisir un maximum de 120 caractères.",
    max50Char: "Veuillez saisir un maximum de 50 caractères.",
  },
  camera: {
    listHeading: "CAMÉRA",
    camera_serial_no: "N° S.",
    cameraStatus: "Statut",
    vehicles: "Véhicule",
    simState: "Statut SIM",
    dateTimeFrom: "Date/ heure de",
    dateTimeTo: "Date/heure a",
    lastConnectTime: "Dernière connexion",
    lastDisconnectTime: "Dernière déconnexion",
    vehicle: "Véhicule",
    event_type: "Type d'événement",
    camera_view: "Afficher",
    event_level: "Niveau",
    date: "Date",
    time: "Heure",
    cycle: "Cycle",
    startDate: "DATE DE DÉBUT",
    endDate: "DATE DE FIN",
    Fleet: "Flottes",
    tabs: {
      dataUsage: "Utilisation des données",
      events: "Événements",
    },
  },
  cameraEvents: {
    listHeading: "Événements caméra",
    event_count: "Nombre d'événements",
    event_type: "Type d'événement",
    last_occurrence: "Dernière occurrence",
    vehciles: "Véhicules",
    totalcounts: "Nombre total d'événements",
    eventsTypes: "Types d'événements",
  },
  manageProfile: {
    editProfile: {
      heading: "Modifier le profil",
    },
  },
  common: {
    deactivate: "Désactiver",
    "Cell Phone": "TÉLÉPHONE",
    "Confirm Password": "Confirmer le mot de passe",
    resetPassword: "Réinitialisation du mot de passe",
    companyInfo: "Informations sur l'entreprise",
    noDataAvailable: "Pas de donnees disponibles",
    noOfTruck: "Nombre de camions",
    subscriptionTier: "Niveau d'abonnement",
    payButtonText: "Mettre à jour la carte maintenant",
    expiredContract: "Your account has been restricted. Please update the card or contact your service provider to activate.",
    expiredContractPay: "Your account has been restricted. Please pay pending bill or contact your service provider to activate.",
    payButtonTextPay: "Payer maintenant",
    saveCCButtonTextPay: "Payer maintenant",
    saveCCButtonText: "Mettre à jour la carte de crédit",
    cardHolder: "Titulaire de la carte",
    updateCardDetails: "Mettre à jour la carte de crédit",
    adminProperty: "ADMIN'S PROPERTIES",
    costperTruck: "Coût par camion (Global) $",
    costPerTruckPrime: "Coût par camion (Prime8 ELD) $",
    costPerTruckXtreme: "Coût par camion (Xtreme) $",
    costperTruckFleet: "Coût par camion (Fleet Xpress) $",
    startDate: "DATE DE DÉBUT",
    acceptPopup: "Oui, acceptez-le",
    account: "Compte",
    accountNumber: "Nom du compte",
    actions: "Actions",
    activateMessage: "Vous allez activer cet utilisateur",
    activateMessageAdmin: "You will activate this Admin User!",
    activateMessageReseller: "You will activate this Reseller!",
    add: "ajouter",
    address: "Adresse",
    admin: "ADMIN",
    alerts: "alertes",
    updateCard: "Mettre à jour la carte de crédit",
    paymentInfo: "Informations de facturation",
    alertSp: "Avis de conformite",
    all: "Tout",
    annotation: "Annotation",
    assignedDriver: "Conducteur assigne",
    assignedVehicle: "Véhicule assigné",
    atleast2Chars: "Veuillez entrer au moin 2 caracteres",
    atleast4chars: "Veuillez entrer au moin 4 caracteres",
    authenticate: "Authentifier",
    authenticateMFA: "Authentifier",
    back: "Retour",
    backToList: "Retour à la liste",
    breadcrumb: "Filtres appliques:",
    bulkDownloadReport: "Rapports de telechargement groupe",
    businessAddress: "Adresse professionnelle",
    camera: "CAMÉRA",
    cameraPassword: "MOT DE PASSE DE LA CAMÉRA",
    cameraSerialNo: "Camera Serial No",
    cameraStatus: "État caméra",
    cameraUrlNotFound: "Votre comte n'est pas enregistre dans le portail de l'appareil-photo.  Veuillez vous inscrire sure le portail de l'appareil-photo et reessayer.",
    cancel: "Annuler",
    viewCompanies: "Afficher les entreprises",
    cardDetails: "Details de las carte mis a jour avec succes",
    carrierName: "Transporteur",
    cellPhone: "TÉLÉPHONE",
    choosePortal: "Choisir le portail",
    city: "ville",
    claimAdjuster: "Expert en sinistres",
    clear: "Effacer",
    clearAll: "Tout effacer",
    coDriver: "Copilote",
    coDriverId: "coDriverId",
    company: "Entreprise",
    dot: "Point n°",
    activeTrucks: "Camions Actifs",
    payment: "Détails de facturation",
    contractLength: "La duree du contrat",
    contractExpiration: "Expiration du contrat",
    registrationDate: "Date d'inscription",
    companyType: "Type d'entreprise",
    confirm: "Confirmer",
    confirmPassword: "Confirmer le mot de passe",
    confirmPasswordMessage: "Veuillez entrer a nouveau la meme valeur",
    createAdmin: "Création de l'administrateur réussie",
    createResellerUser: "Utilisateur revendeur créé avec succès",
    currentOdometer: "ODOMÈTRE ACTUEL",
    customerName: "Nom du client",
    customPolicyTemplate: "Cliquez pour afficher le modèle de police personnalisé",
    cycleRule: "Règle du cycle",
    dataImportSuccess: "Les donnees on ete importees avec suces",
    date: "Date",
    dateFrom: "Date de début",
    datePicker: "MM/JJ/AAAA",
    dateTo: "Date a",
    delete: "supprimer",
    deleteAdminResellerInfo: "Cette action ne peut être annulée.",
    deleteDepartment: "Departement suprime avec succes",
    deletePopup: "Oui,Supprimez-le",
    deleteRegion: "Region supprime avec succes",
    deleteTerminal: "Terminal supprime avec succes",
    deleteUserAdminReseller: "Are you sure want to delete Reseller User?",
    deleteVehicles: "Are you sure want to delete this vehicle?",
    deleteTrailer: "Are you sure want to delete this trailer?",
    department: "SERVICE",
    departmentAdded: "Departement ajoute avec succes",
    departments: "SERVICES",
    departmentUpdated: "Departement mis a jour avec succes",
    description: "Description",
    deviceSn: "Numéro de série de l'appareil",
    deviceType: "Type d'appareil invalide",
    disableMFA: "Désactiver l'authentification multifactorielle",
    disablePopup: "Oui, désactiver",
    discount: "Pourcentage de réduction",
    distance: "Distance",
    document: "Document",
    documents: "Documents",
    dotNumber: "Numero de DOT",
    dotOfficerCode: "Code oficier DOT",
    driver: "Conducteur",
    driverId: "driverId",
    driverName: "NOM DU CONDUCTEUR",
    driverNamejobName: "Nom du poste",
    driverPhone: "Telephone de conducteur",
    drivers: "Conducteur",
    drivingState: "Etat de conduire",
    edit: "Modifier",
    email: "Courriel",
    emailValidationMessage: "Veuillez entrer un format d'email valide",
    employeeId: "IDENTIFIANT DE L'EMPLOYÉ",
    en: "Anglais",
    fr: "Français",
    enableMFA: "Activer l'authentification multifactorielle",
    enablePopup: "Oui, activer",
    endTime: "Heure de fin",
    es: "Espagnol",
    export: "Exportation",
    exportAll: "Tout exporter",
    exportData: "Exporter les données",
    failed: "Échec de la mise à jour",
    fieldRequiredMessage: "Ce champ est requis",
    filterRequiredMessage: "Veuillez selectionner au moins un filtre",
    finish: "Terminer",
    firstname: "PRÉNOM",
    firstName: "PRÉNOM",
    fleetManager: "Gestionnaire de flotte",
    fleetManagerDefault: "Gestionnaire de flotte (par défaut)",
    fleetopsUrlNotFound: "Cette fonctionnalite n'est pas configuree pour votre compte",
    fromLocation: "De",
    fullName: "Nom complet",
    fullname: "Fullname",
    geocodedLocation: "Emplacement geocode",
    gvw: "PTC",
    hardwareDevice: "MATÉRIEL",
    hideNotification: "Masquer la notification",
    hireDate: "DATE DE LOCATION",
    history: "Historique",
    hours: "heures",
    hoursDriving: "Heures de conduite",
    hoursWorked: "Heures travaillées",
    import: "Importer",
    importUser: "Importer les utilisateurs",
    isValidVin: "Numero de VIN doit etre dix-sept caracteres.  Chiffres et lettres uniquement. I, O our Q sone pas autorises.",
    language: "Langue",
    lastname: "NOM",
    lastName: "NOM",
    licenceNumber: "NUMÉRO DE PERMIS",
    liveCamera: "Live-Streaming",
    location: "Emplacement",
    locationAdded: "Emplacement ajoute avec succes",
    locationDeleted: "Emplacement supprime avec succes",
    locationOfLogSigning: "Emplacement de la signature du journal",
    locationUpdated: "Emplacement mis a jour avec succes",
    logbookDetails: "Journal quotiedien de:",
    logHistory: "Historique des journaux quotidiens",
    lossControl: "Contrôle des pertes",
    mainAddress: "Adresse principale",
    mainInformation: "Informations principales",
    make: "Marque",
    manageAdmin: "Gérer l'administration",
    manageDailyDocuments: "Gérer les documents quotidiens",
    manageSubscription: "Gérer les abonnements",
    max30Chars: "Maximum allowed 50 characters.",
    maxChar: "maximum 50 character",
    maxValueMessage: "maximum 100%",
    mechanic: "MÉCANICIEN",
    message: "Messagerie",
    mfacode: "Code MFA",
    minChar: "minimum one char required",
    minimumRow: "un minimum de 1 ligne est requis",
    minValueMessage: "minimum 0%",
    modifiedBy: "Modifie par",
    mph: "MPH",
    name: "Nom",
    next: "Suivant",
    nextMaintenanceDate: "PROCHAINE DATE DE MAINTENANCE",
    nextMaintenanceMileage: "PROCHAIN KILOMÉTRAGE D'ENTRETIEN",
    no: "Non",
    noBreadcrumbData: "Aucune donnee troubee pour tracer le BreadCrumb",
    noData: "ien a afficher",
    noDataToPlot: "Aucune donnée à représenter",
    noDuplicateEmail: "No duplicate accident emails are allowed",
    noMoreThan9: "Veuillez noe pas entrer plur de 9 caracteres",
    note: "Remarque",
    notes: "Remarques",
    notificationList: "Liste des notifications",
    ok: "OK",
    otherContact: "AUTRES CONTACTS",
    pageNotFound: "Page introuvable",
    partAdded: "Pieces ajoutees avec succes",
    password: "Mot de passe",
    passwordIsNotMatching: "Le mot de pass de confirmation ne correspond pas au mot de pass",
    passwordValidMessage: "Le mot de passe doit avoir au moins un caractere majuscule, un caractere miniscule, un chiffre, un caractere special, au moins 6 caracteres at au plus 15 caracteres",
    paymentName: "Nom sur la carte",
    paymentplaceholder: "",
    pdf: "PDF",
    phone: "Téléphone",
    phoneNumber: "Numéro de téléphone",
    photos: "Photos",
    plateNumber: "Numéro de plaque",
    pleaseSelect: "Veuillez selectionner",
    policiesAndProcedures: "Les politiques et les procedures",
    policy: "Police",
    popupMessage: "Vous ne pourrez pas recuperer cet utilisateur!",
    popupMessageAdmin: "You are deactivating this Admin User!",
    popupMessageReseller: "You are deactivating this Reseller!",
    positiveNumberMessage: "Doit etre superieur a zero",
    previous: "Précédent",
    privacyPolicy: "Politique de confidentialite",
    proceedToAdd: "Passer à l'ajout",
    proceedToImport: "Passer à l'importation",
    producerCode: "Code revendeur",
    qrCode: "Entrer le code",
    radiusSection: "Paramètres du rayon",
    radiusTolerance: "Tolérance du rayon",
    recoverConfirm: "Vous ne pourrez pas recuperer ce vehicule",
    refresh: "Refraichir",
    regeneratePdf: "Régénérer le PDF",
    region: "RÉGION",
    removeMFA: "Supprimer l'authentification multifactorielle",
    reported: "Signalé",
    Reseller: "Revendeur",
    resellerCreate: "Revendeur créé avec succès",
    resellerUpdate: "Revendeur mis à jour avec succès",
    reset: "Reinitialiser",
    role: "Rôle",
    save: "Enregistrer",
    saveChanges: "Enregistrer les modifications.",
    saveRegion: "Region ajoute avec succes",
    search: "RECHERCHER",
    searchBox: "Rechercher...",
    searchReseller: "Rechercher...",
    searchSubReseller: "Rechercher...",
    select: "Sélectionner",
    send: "Envoyer",
    serviceCenter: "Centre de service",
    serviceManager: "Gestionnaire de service",
    setUpMFA: "Configurer MFA",
    shipDocs: "Documents d'expédition",
    show: "Afficher",
    SHOW: "Afficher",
    startTime: "Heure de début",
    state: "État",
    status: "Statut",
    subject: "Objet",
    submit: "Soumettre",
    subResellerCreate: "Sub Reseller created successfully",
    subResellerUpdate: "Sub Reseller updated successfully",
    successfull: "Successfull",
    summary: "Resume",
    superAdmin: "Super administrateur",
    sureConfirm: "Etes-vous sur?",
    sureDeleteRequest: "Êtes-vous sûr de vouloir supprimer cette demande ?",
    syncData: "Synchroniser les données",
    tableEmptyMessage: "Aucune donnee disponible",
    template: "Modele",
    terminal: "TERMINAL",
    terminalAdd: "Terminal ajoute avec succes",
    terminalAddress: "Adresse du terminal",
    terminalUpdate: "Terminal mis a jour avec succes",
    termsValidation: "Veuillez accepter les termes et conditions pour continuer",
    testCompany: "Société test",
    timeZone: "Your timezone cannot be obtained from the address entered. Please select your timezone below:",
    timeZoneOffsetFromUTC: "DÉCALAGE DU FUSEAU HORAIRE PAR RAPPORT À L'UTC",
    timzone: "Fuseau horaire",
    toLocation: "Vers",
    tools: "Outils",
    total: "Total",
    totalDistance: "Distance total",
    totalHoursWorked: "Total de heures travaillees",
    trailer: "Remorque",
    trailerInformation: "Information de remorque",
    trailerList: "Liste des remorques",
    trailerName: "Remorques",
    truckId: "ID de camion",
    type: "Type",
    unAuthorized: "Non autorise",
    underWriter: "Souscripteur",
    unhandled: "Non gere",
    update: "Mise à jour",
    updateAdmin: "Mise à jour de l'administrateur réussie",
    updatedTime: "Heure mise a jour",
    updateRegion: "Region mise a jour avec succes",
    updateResellerUser: "Utilisateur revendeur mis à jour avec succès",
    upgrade: "Mise à niveau",
    upload: "Telecharger",
    usdotDetails: "Numero de USDOT supprime avec succes",
    user: "Utililisateur",
    userCredentials: "Informations d'identification de l'utilisateur",
    userInformation: "Information d'utilisateur",
    userMainInformation: "Informations principales sur l'utilisateur",
    userName: "Nom d'utilisateur",
    validLicenseNumber: "License Number should contain alpha numeric characters only.",
    validName: "Veuillez ne pas entrer plus de 10 caracteres",
    validNumberMessage: "Veuillez entrer un numero valide",
    validNumFormat: "Merci de remplir le bon format",
    vehicle: "Véhicule",
    vehicleId: "ID DU VÉHICULE",
    vehicleInformation: "Information de vehicule",
    vehicleList: "Liste des véhicules",
    vehicleName: "Nom du véhicule",
    vehicles: "Véhicules",
    version: "Version",
    view: "Afficher",
    viewLess: "Afficher moins",
    viewMore: "En savoir plus",
    webfleetProvider: "Fournisseur Webfleet",
    WFConnect: "Informations sur le compte WF.connect",
    yes: "Oui",
    zipCode: "Code postal",
    noteDesc: "Description des remarques",
    updatedBy: "Mis à jour par",
    updatedOn: "Mis à jour le",
    saveNote: "Enregistrer les notes",
    searchText: "Rechercher...",
    companyTierChange: "Do you want to assign reseller default tier ({{defaultTier}}) to current company subscription Tier ({{currentTier}})?",
    companyTierRemoveText: "Do you want to change reseller default tier ({{defaultTier}})?",
    companyTierChangeText: "Do you want to assign reseller default tier to current company subscription Tier?",
    resellerAddTierChange: "Do you want to assign parent reseller default tier ({{defaultTier}}) to current reseller ({{currentTier}})?",
    resellerAddTierChangeText: "Do you want to assign parent reseller default tier to current reseller?",
    resellerEditTierChange: "Do you want to change current reseller tier ({{currentTier}}) with parent reseller tier ({{defaultTier}})?",
    resellerEditTierChangeText: "Do you want to change current reseller tier with parent reseller tier?",
    getaQuotes: "Obtenir un devis",
    customStateErrorMessage: "Invalid Jurisdiction. please select Jurisdiction",
    configuration: "Configuration",
    emailAlerts: "Alertes par e-mail",
    alertToEmailInfo: "If no events are selected, it will be considered that all events should be sent.",
    validName10000: "Maximum allowed count is 10000",
    lastUpdated: "Derniere mise a jour",
    viewAll: "Tout afficher",
    followVehicle: "Suivre le véhicule",
    deleteMessage: "You can't able to restore the state!",
    cameraTypeChangeWarning: "You are changing camera type to {{camerType}}. This will reset the Camera serial number and password",
    quoteId: "Numero de DOT",
    cardDetailsSavedSuccesfully: "Détails de la carte enregistrés avec succès",
    max20Char: "Maxmium character limit exceeds.",
    max60Char: "Maxmium 60 character allowed",
    onlyletterNumber: "Only letters and numbers are allowed",
    noofIntialTrucks: "Nombre de camions initiaux",
    noofIntialCamera: "Nombre de caméras initiales",
    initialCamera: "Nombre initial de caméras",
  },
  avatarMenu: {
    switchToOld: "Passer a l'ancienne vue",
    switchToNew: "Passer a un Nouvelle Vue",
    messaging: "Messagerie",
    logout: "Déconnexion",
  },
  bulkDelete: {
    alertSuccess: "Les données ont été importées avec succès.",
    deleteError: "An error occurred while deleting",
    imported: "Les données ont été importées avec succès.",
    deleteVehicle: "Following {{count}} vehicles are flagged for deletion. Do you want to continue?",
    allSuccess: "Succes",
    deleted: ": The following {{count}} vehicles have been deleted.",
  },
  leftMenu: {
    feedback: "Retroaction",
    developerRequests: "Demandes des développeurs",
    downloadCenter: "Centre de téléchargement",
    reports: "Rapports",
    IFTAReport: "Rapport de IFTA",
    fuelReport: "Rapport de consommation de carburant",
    dailyDocuments: "Documents quotiediens",
    documents: "Documents",
    policiesProcedures: "Les politiques et les procedures",
    DOTAudit: "DOT AUDIT",
    Audit: "Audit",
    USDOT: "Gestion du numero USDOT",
    companyData: "Données sur l'entreprise",
    filters: "Filtres",
    inspections: "Inspections",
    repairMaintenance: "Réparation et entretien",
    accidents: "Accidents",
    vehicles: "Véhicules",
    users: "Utilisateurs",
    logs: "Journaux",
    csaViolation: "Infractions de CSA",
    department: "SERVICES",
    camera: "CAMÉRA",
    companies: "Entreprises",
    freight: "Cargaison",
    dashboard: "Tableau de bord",
    scoreCard: "Fiche de score",
    accountReport: "Rapport sur les comptes",
    alerts: "Alertes caméra",
    cameraAlerts: "Alertes caméra",
    churnReport: "Rapport sur le taux de désabonnement",
    dailyLogs: "Gérer les journaux quotidiens",
    dataUsage: "Utilisation des données",
    debugLogs: "Journaux de débogage",
    fmcsaTitle: "Réponses FMCSA",
    fmcsaTitleList: "Liste FMCSA",
    resellers: "Revendeurs",
    revenueReport: "Rapport sur les revenus",
    serviceRequest: "Demande de service",
    serviceRequests: "Demandes de service",
    subResellers: "Sub Resellers",
    subscription: "abonnement",
    trailerList: "Liste des remorques",
    trailers: "Remorques",
    userReport: "Rapports utilisateur",
    vehicleList: "Liste des véhicules",
    wlBilling: "Facturation WL",
    wlBillingInfo: "Informations de facturation WL",
  },
  dashboard: {
    udNotification: "Vous avez un temps de conduite non identifie/non attribue.  Veuillez acceder a l'onglet journaux et attriguer ces journaux au bon conducteur.",
    driverStatus: {
      DRIVING: "MANAGE USERS - DRIVING",
      ON_DUTY: "GERER LES UTILISATEURS-EN SERVICE",
      SLEEPER_BERTH: "GERER LES UTILISATEURS-COUCHETTE",
      OFF_DUTY: "GERER LES UTILISATEURES-PAS EN SERVISE",
    },
    notInUseVehicles: {
      pageHeading: {
        INSHOP: "MANAGE VEHICLES - IN SHOP",
        OUTOFSERVICE: "MANAGE VEHICLES - OUT OF SERVICE",
      },
      listHeading: {
        INSHOP: "Liste des véhicules en atelier",
        OUTOFSERVICE: "Liste des véhicules hors service",
      },
    },
    tabs: {
      driverBehavior: "Comportement du conducteur",
      vehicleStatus: "Etat du vehicule",
      dailyLogs: {
        heading: "Journaux quotidiens",
      },
      driverStatus: {
        heading: "Statut des conducteurs",
        lastKnownLocation: "Dernier emplacement connu",
        unit: "UNIT",
        driveTimeRemaining: "Temps de conduite restant",
        timeUntilBreak: "Temps jusqu'a la pause",
        onDutyTimeRemaining: "Temps de service restant",
        dutyCycleRemaining: "Cycle de service restand",
        currentStatus: "Statut actuel",
        engineSpeed: "Vitesse du moteur",
        lastUpdated: "Derniere mise a jour",
        driveTime: "Temps de conduite restant",
        onDutyTime: "Temps en service",
        eld: "ELD details de deconenecte",
      },
      alerts: {
        enableNotification: "Activer les notifications",
        heading: "alertes",
      },
      potentialViolations: {
        heading: "Violations potentielles",
        pageHeading: "Notifications",
        violationType: "Type de violation",
      },
      radiusComplianceAlerts: {
        company: "Nom du titulaire de la police",
        radius: "Rayon",
        type: "Type",
        radiusExperience: "Expérience du rayon",
        description: "Description",
        date: "Date",
        overage: "Dépassement",
        monthInViolation: "Mois en infraction",
        lossControl: "Contrôle des pertes",
        underwriter: "Souscripteur",
      },
      radius: "Rayon",
      severity: "Gravite",
      csaSnapshot: "Instantane CSA",
      recentAccidents: "Accidents récents",
      developerRequests: "Demandes d'autorisation de developpeur",
      overview: "Aperçu",
    },
    header: {
      TOTALDRIVERS: "Nombre total de conducteurs actifs",
      ONDUTY: "En service",
      DRIVING: "Conduite",
      SLEEPER: "COUCHAGE",
      OFFDUTY: "Hors service",
      TOTALTRUCKS: "Nombre total de camions",
      AVAILABLETRUCKS: "Camions disponible",
      INSHOP: "En atelier",
      OUTOFSERVICE: "Hors service",
      text: "Résumé de l'entreprise",
    },
  },
  api: {
    errors: {
      noService: "Service Indisponibel Temporairement",
      networkError: "Erreur interne du serveur",
    },
  },
  resellers: {
    addHeading: "Ajouter un revendeur",
    editHeading: "Détails du revendeur",
    listHeading: "Gérer les revendeurs",
    listSubResellerHeading: "Manage Sub Resellers",
    code: "Code",
    joinedDate: "Date d'adhésion",
    trucksCount: "No. of Trucks",
    path: "Chemin",
  },
  users: {
    addDriver: "Ajouter un conducteur",
    addHeading: "Ajouter un utilisateur",
    addNewDriver: "Ajouter un nouveau conducteur",
    addNewUser: "Ajouter un nouvel utilisateur",
    admins: "Administrateurs",
    adminUsers: "Utilisateurs administrateurs",
    aGExemption: "EXEMPTION AG",
    All: "Tout",
    bigDayShortHaul: "Big Day Short Haul",
    claimManagers: "Experts en sinistres",
    drivers: "conducteurs",
    driverStatusHistory: "Historque de l'etat du conducteur",
    DVIROnly: "DVIR uniquement",
    editHeading: "Détails de l'utilisateur",
    enableNonDOTTrip: "Activer l'excursion non-DOT",
    enablePersonalConveyance: "Activer transport personnel",
    enableYardMoves: "Activer les deplacements de cour",
    exemptFromUsingELD: "Exempte d'utiliser ELD",
    expirationDate: "Date d'expiration",
    fleetManager: "Gestionnaire de flotte",
    fleetUsers: "Utilisateurs de la flotte",
    joined: "Joined",
    listHeading: "Gérer les utilisateurs",
    lossControllers: "Loss Controls",
    mechanicListHeading: "Gerer les mecaniciens",
    mechanics: "Mécaniciens",
    profileHeading: "Modifier le profil",
    quickFilter: "Filtres rapides",
    resellerUsers: "Utilisateurs revendeurs",
    resetPasswordHeading: "Réinitialisation du mot de passe",
    searchMechanic: "Chercher mecanicien",
    selectFileToUpload: "Sélectionnez le fichier à télécharger",
    serviceManagers: "Gestionnaires de services",
    underWriters: "Souscripteurs",
    userInfo: "Informations utilisateur",
    vehicleForDriver: "Véhicule pour le conducteur",
    vehicleForMechanic: "Véhicule pour le mécanicien",
  },
  logs: {
    addHeader: "Information d'utilisateur",
    addLogHeader: "Ajouter des journaux",
    addNewRow: "Ajouter nouveau ligne",
    allDutyTimeTracker: "Informe de seguimiento de todo el tiempo de servicio,",
    archiveLogsHeader: "Archiver les journaux",
    assignedDriver: "Conducteur assigne",
    backToDashboard: "RETOURNER",
    codriver: "Nom de copilote",
    dailyLogExportMessage: "Exporter le statut signé du journal quotidien",
    dateInUtc: "Date (dans UTC)",
    editHeading: "Modifier le journal quotidien",
    history: "Historique des journaux quotidiens",
    location: "Emplacement",
    logBook: "Journal",
    logLocation: "Emplacement de signature du journal",
    logs: "Journaux",
    manageLogsHeader: "Gérer les journaux",
    manageLogsHeaderSigned: "Journaux signes",
    manageLogsHeaderUnSigned: "Temps reel/journaux non signes",
    noDataMessage: "Demand invalide.  Cliques ici pour revenir au tableau de bord",
    notes: "Remarques",
    noViolation: "Pas de donnee d'infraction pour le journee",
    destinationCoDriver: "Réassigner à",
    reassign: "Envoyer la demande",
    reassignConfirm: "Êtes-vous sûr de vouloir soumettre cette demande de réaffectation d'événement de copilote ?",
    reassignDriverChangeBlocked: "Les changements de conducteur sur les événements de conduite éligibles doivent être soumis via la demande de réaffectation.",
    reassignEvent: "Demande de réaffectation du journal de conduite",
    reassignEventDetails: "Détails de l'événement",
    reassignEventSubtitle: "Transférez cet événement de conduite à un autre copilote.",
    reassignRequestDetails: "Demande de réaffectation",
    reassignPendingRequest: "Une demande de réaffectation de copilote est en attente. L'enregistrement complet du journal est désactivé jusqu'à ce que la demande soit résolue.",
    reassignTypeUd: "Conducteur non identifié",
    reassignTypeCoDriver: "Copilote",
    reassignPendingWithEvent: "Une demande de réaffectation de {{type}} est en attente pour {{event}}. La modification du journal est désactivée jusqu'à ce que la demande soit résolue.",
    reassignSuccess: "La demande de réaffectation d'événement de copilote a été envoyée avec succès.",
    oildFieldWaiting: "Champ petrolifere-en attente",
    spireonTitle: "Journaux quotidiens",
    stateModifier: "Modificateur d'etat",
    status: "Statut",
    Submit: "Enregistrer",
    timeFrom: "Heure de",
    timeTo: "Heure a",
    unassignedDriveTime: "Temps de conduite non attribue",
    reassignToCoDriver: "Réassigner au copilote",
    reassignToUd: "Réassigner au conducteur non identifié",
    reassignToUdHeading: "Demande de réaffectation UD",
    sendRequest: "Envoyer la demande",
    udReassignSuccess: "La demande de réaffectation a été envoyée avec succès.",
    udReassignEditDisabled: "La modification du journal est désactivée car une demande de réaffectation est en attente.",
    undefinedDriverHeader: "Journaux de conduite non identifiés",
    unidentifiedDriverProfile: "Profil de conducteur non identifie",
    UpdateEvents: "Mettre a jour les evenements",
    UpdateGraph: "Mettre a jour le graphique",
    viewDocument: "afficher les documents",
    violations: "Infractions",
  },
  dca: {
    dcAlert: "Alertes de code de diagnostic",
    dateFrom: "Date de début",
    dateTo: "Date a",
    code: "Code",
    description: "Description",
    startTime: "Heure de début",
    endTime: "Heure de fin",
    search: "Recherche par code",
  },
  vehicles: {
    activateIt: "Oui, activez-le!",
    addHeading: "Ajouter un véhicule",
    assignedVehicles: "Véhicules assignés",
    cameraType: "TYPE DE CAMÉRA",
    cameraSerialNo: "Camera serail number",
    cameraPassword: "MOT DE PASSE DE LA CAMÉRA",
    deactivateResellerUser: "Oui, désactiver !",
    deactivateUser: "Oui, desactiver l'utilisateur!",
    deleteReseller: "Oui, supprimer !",
    deleteUser: "Oui, supprimer !",
    drivers: "conducteurs",
    editHeading: "Modifier le véhicule",
    email: "E-mail",
    empId: "EMP ID",
    exportUser: "Exporter des utilisateurs",
    fuelType: "TYPE DE CARBURANT",
    fullName: "Nom complet",
    importUserTemplate: "Importer des modeles d'utilisateur",
    lastLogin: "Dernière connexion",
    listHeading: "Gérer les véhicules",
    manufact: "Fabrication",
    manufacturer: "Fabricant",
    model: "Modèle",
    role: "Rôle",
    searchUser: "Rechercher un utilisateur",
    searchVehicle: "Recherche par véhicule",
    searchVehicleTrailer: "Recherche par véhicule/remorque",
    type: "Type",
    unitId: "ID de l'unité",
    users: "Utilisateurs",
    vehicleType: "Type de véhicule",
    vin: "NIV",
    wlId: "ID CRM",
    year: "Année",
    nextMaintenanceDate: "PROCHAINE DATE DE MAINTENANCE",
    nextMaintenanceMileage: "PROCHAIN KILOMÉTRAGE D'ENTRETIEN",
    camera: "CAMÉRA",
    currentOdometer: "ODOMÈTRE ACTUEL",
    notes: "Remarques",
    deviceType: "Type d'appareil invalide",
    hardwareDevice: "MATÉRIEL",
    deviceSn: "Device Serial No:",
    trailerName: "Remorque",
    plateNumber: "Numéro de plaque",
    make: "Marque",
    gvw: "PTC",
    tabs: {
      listVehicles: "Liste des véhicules",
      listTrailers: "Liste des remorques",
      roadInspection: "Inspection routiere",
    },
    addTrailer: "Ajouter une nouvelle remorque",
    addVehicle: "Ajouter un nouveau véhicule",
    cameraId: "ID caméra",
    cameraStatus: "Statut",
    dateTimeFrom: "Date/ heure de",
    dateTimeTo: "Date/heure a",
    exportTrailer: "Exporter les bandes-annonces",
    exportVehicle: "Exporter vehicules",
    importTra: "Remorques d'importation",
    importTrailerTemplate: "Modele d'importation de remorques",
    importVeh: "Importer des véhicules",
    importVehicleTemplate: "Modele d'importation de vehicules",
    inspectionForm: "Formulaire d'inspection",
    mechanics: "MÉCANICIEN",
    seatBeltStatus: "Etat de la ceinture de securite",
    trackVehicle: "Traquer le vehicule",
    trailerType: "Type de remorque",
  },
  chat: {
    sendMessage: "Envoyer message",
    selectDriver: "A: Chercher",
    newConvo: "Nouvelle conversation",
    broad: "Diffuser",
    search: "Rechercher...",
    type: "Type",
  },
  trailers: {
    deleteIt: "Oui,Supprimez-le",
    recoverConfirm: "Vous ne pourrez pas recuperer ce remorque!",
    trailerType: "Type de remorque",
    addHeading: "Ajouter une remorque",
    editHeading: "Modifier la remorque",
  },
  roadInspection: {
    driverId: "Identifiant du conducteur",
    defectFound: "Defaut trouve",
  },
  reports: {
    downloadReports: "telecharger les rapports",
  },
  accidents: {
    heading: "Gestion des accidents",
    witnessStatement: "Déclaration du témoin",
    accidentReport: "Rapport d'accident",
    dateAndTime: "Date et heure",
    viewWitness: "Voir les temoins",
    viewReport: "Afficher le rapport",
    viewReceipt: "Voir le recu",
  },
  eld: {
    all: "Tout",
    delivery_receipts: "Demande de livraison",
    dispatch_records: "Enregistrement d'envoi",
    bills_of_landing: "Connaissement",
    receipts: "Reçu",
    weigh_tickets: "Billet de pesee",
    communication_records: "Enregistrement des communications",
    other_documents: "Autre document",
  },
  documents: {
    listHeading: "Documents",
  },
  developerRequests: {
    listHeading: "Demandes d'autorisation de developpeur",
    developerName: "Nom du developpeur",
  },
  departments: {
    terminalsAndDepartments: "Terminaux et Departements",
    noLocations: "Aucun emplacement ajoute",
    noDepartments: "Aucun departement sous ce terminal",
    addTerminal: "Ajouter terminal",
    editTerminal: "Editer terminal",
    addRegion: "Ajouter region",
    editRegion: "Editer region",
    regionName: "Nom de region",
    fleetManagers: "Gestionnaires de flotte",
    dot: "Point n°",
    addDepartment: "Ajouter departement",
    editDepartment: "Editer departement",
    addLocation: "Ajouter Emplacement",
    editLocation: "Editer Emplace ment",
    deleteTerminal: "Effacer Terminal",
    deleteDepartment: "Effacer Departement",
    serviceCenters: "Centres de Service",
    filter: "Filtres",
    addFilter: "Definir le filtre",
  },
  registration: {
    addDepartment: "Ajouter departement",
    addFilter: "Definir le filtre",
    addLocation: "Ajouter Emplacement",
    addRegion: "Ajouter region",
    addTerminal: "Ajouter terminal",
    deleteDepartment: "Effacer Departement",
    deleteTerminal: "Effacer Terminal",
    dot: "Point n°",
    editDepartment: "Editer departement",
    editLocation: "Editer Emplace ment",
    editRegion: "Editer region",
    editTerminal: "Editer terminal",
    filter: "Filtres",
    fleetManagers: "Gestionnaires de flotte",
    noDepartments: "Aucun departement sous ce terminal",
    noLocations: "Aucun emplacement ajoute",
    regionName: "Nom de region",
    serviceCenters: "Centres de Service",
    terminalsAndDepartments: "Terminaux et Departements",
    companyInfoHeading: "Informations sur l'entreprise",
    userInfoHeading: "Informations sur le gestionnaire de flotte",
    initialTrucks: "Nombre de camions",
    maintenancePeriod: "Période de maintenance (mois)",
    maintenanceMileage: "Kilométrage d'entretien",
    subscriptionTier: "Niveau d'abonnement",
    contractLength: "Duration du contrat",
    createAccount: "Creer un comte",
    producerCode: "Code de producteur",
    iAgree: "Je suis d'accord au",
    termsOfUse: "Conditions d'utilisation",
    accept: "Accepter",
    totalAmount: "Montant total: $",
    paymentConfirmation: "Confirmation de paiement",
    noOfTrucks: "Nombre de camions",
    costperTruck: "Coût par camion ($)",
    salesTax: "Taxe de vente ($)",
    discount: "Reduction (%) le cas echeant",
    total: "Montant total ($)",
    confirm: "Confirmer",
    iAcceptAll: "J'accepte les termes et conditions suivants",
  },
  csaViolation: {
    listHeading: "Infractions de CSA",
    dvirLink: "Lien de DVIR",
    dvirStatus: "Statue de DVIR",
    roadsideDot: "Inspection DOT routiere",
    workOrder: "Demande de service",
    workOrderStatus: "Statut de demand de service",
    oos: "OOS",
    severity: "Gravite",
  },
  iftaMileage: {
    listHeading: "Kilométrage IFTA",
    search: "RECHERCHER",
    notLessThanZero: "Meter reading should not be less than zero",
    addressError: "Invalid address.Can't able to find address.",
    endMeterError: "end meter should be greater than start meter",
    tooltip: "Telecharger l'historique GPS du camion",
    hideLabel: "Masquer les etats sans kilometrage",
    activeVehicles: "Vehicules actives",
    deactivateVehicles: "Vehicules desactives",
    odometer: "Calculer à partir du compteur kilométrique",
    updateMiles: "Mettre à jour les kilomètres",
    totalMiles: "Milles totaus",
    totalTaxableMiles: "Total des kilomètres imposables",
    truck: "Camion",
    Jurisdiction: "JURIDICTION",
    generateReport: "Générer un rapport",
    fuelUsage: "Carburant acheté",
    newState: "Nouvelle juridiction",
    vehicle: "Recherche par véhicule",
    stateSearch: "Recherche par juridiction",
    gpsBegins: "Beginning GPS Lat & Long",
    gpsEnds: "Ending GPS Lat & Long",
    startMeter: "Démarrer l'odomètre",
    endMeter: "Compteur kilométrique final",
    addState: "Ajouter une juridiction",
    editState: "Modifier la juridiction",
    startCity: "Ville de départ",
    endCity: "Ville de fin",
    taxable: "Imposable",
  },
  fuelConsumption: {
    pageHeading: "Rapport de consommation de carburant",
    search: "Rechercher un rapport par véhicule",
    currentDrivers: "Conducteurs actuels",
    location: "Dernier point de revitaillement",
    Jurisdiction: "JURIDICTION",
    JurisdictionLocation: "Jurisdiction/Location",
    miles: "Milles par gallon",
    history: "Historique des recharges",
    unknown: "Inconnu",
  },
  refillsHistory: {
    pageHeading: "Historique des recharges",
    odometer: "Compteur kilométrique",
    gallons: "Gallons",
    fuelAmount: "Quantité de carburant (gallons)",
    Jurisdiction: "JURIDICTION",
    cost: "Coût total",
  },
  usDotManagement: {
    pageHeading: "Page de gestion des numéros USDOT",
    search: "Rechercher le numéro USDOT",
    usDotNo: "Numero de DOT de EU",
    carrierName: "Nom de transporteur",
    mainAddress: "Adresse au bureau principas",
    zip: "Code postal",
    addDot: "Ajouter un nouveau DOT",
    editDot: "Modifier le DOT",
    message: "Messagerie",
    send: "Envoyer",
  },
  inspections: {
    advancedDvir: "DVIR avancé",
    advancedInput: "Section",
    assetsCount: "Nombre d'actifs",
    assetsName: "Nom de l'actif",
    assetsType: "Assets Type",
    bulkDownloadReport: "Rapport de telechargement groupe",
    customDvir: "DVIR personnalise",
    dvirError: "Type de configuration ou nom de section non entre",
    hasDefects: "A des defauts?",
    inspectionReport: "Rapport d'inspection",
    inspectionType: "Type d'inspection",
    listHeading: "Gérer les inspections",
    listHeading1: "Inspections",
    searchBycompany: "Chercher par Entreprise",
    searchByMechanic: "Chercher par Mecanicien",
    unitType: "Type d'unite",
    user: "Cherchez par utilisateur",
    vehicle: "Recherche par véhicule",
    viewReport: "Afficher le rapport",
  },
  workOrders: {
    addHeading: "Détails de l'ordre de travail",
    addWorkOrders: "Ajouter un ordre de travail",
    assignToServiceCeenter: "Affecter a un autre centre de service",
    assignWorkOrder: "Affecter demand de service",
    cause: "Cause",
    closed: "Ordres de travail clôturés",
    company: "Entreprise",
    concern: "Problème",
    correction: "Correction",
    defectDetails: "DÉTAILS DU DÉFAUT",
    driver: "Conducteur",
    dueDate: "Date d'échéance",
    dvirLocation: "Emplacement DVIR",
    engineOil: "QUANTITÉ D'HUILE MOTEUR",
    fuel: "QUANTITÉ DE CARBURANT",
    hydraulicOil: "QUANTITÉ D'HUILE HYDRAULIQUE",
    inspectionDetails: "Détails de l'inspection",
    inspectionReport: "Rapport d'inspection",
    laborCost: "COÛT DE MAIN-D'ŒUVRE ($)",
    manageMechanics: "Gerer les mecaniciens",
    manageParts: "Gérer les pièces",
    mechanic: "MÉCANICIEN",
    noReport: "Aucun rapport",
    notes: "Remarques",
    open: "Ordres de travail ouverts",
    pageHeading: "Gérer les bons de travail",
    parts: "PIÈCES",
    partsCost: "COÛT DES PIÈCES ($)",
    receipts: "Reçus",
    repairCost: "Cout de reparation",
    reportedDate: "Date rapportee",
    scheduled: "PRÉVU",
    scheduledDate: "Date etabli",
    search: "Recherche d'ordre de travail",
    serviceCenter: "Centre de service",
    serviceRequestEditSuccess: "La demande de reparation de service a ete mise a jour",
    serviceType: "type de service",
    status: "Statut",
    totalCost: "COÛT TOTAL ($)",
    unableToChangeStatus: "Demand de service attribuee a un centre de service.  Impossible d'effectuer cette modification",
    unavailable: "-",
    unitType: "Type d'unite",
    vehicle: "Véhicule",
    viewInspectionreport: "voir le rapport d'inspection",
    viewPhotos: "voir les photos",
    viewPicture: "Voir photo",
    viewReceipt: "Voir le recu",
    viewReport: "Afficher le rapport",
    windShieldFluid: "Windshield washer Quantity",
    workOrderEditSuccess: "Ordre de travail a ete mis a jour",
    workOrderNo: "Numero de demande de service",
  },
  parts: {
    pageHeading: "Gérer les pièces",
    partName: "Pièce",
    partsInventory: "# en inventaire",
    cost: "COÛT DES PIÈCES ($)",
    addPart: "Ajouter piece",
    partTitle: "PIÈCES",
    costError: "Veuillez entrer une valeur supieure a out egale a 0",
  },
  companyData: {
    addPageHeading: "Ajouter une entreprise",
    advanceSettings: "Parametres avances",
    assetsType: "Assets Type",
    cancelSubscription: "Annuler l'abonnement",
    companyName: "Nom d'etreprise",
    contactPerson: "personne à contacter",
    contractExpirationDate: "Date d'expiration du contrat",
    currentSubscriptionCost: "Coût actuel de l'abonnement",
    defaultCycleRule: "RÈGLE DE CYCLE PAR DÉFAUT",
    DVIR: "DVIR",
    editPageHeading: "Modifier la société",
    enablecompanyCheckbox: "Activer en attente - champ petrolifere",
    exceptions: "Exceptions",
    expiryDate: "Date d'expiration de l'assurance",
    fleetManagerInformation: "Informations sur le gestionnaire de flotte",
    garagingAddress: "Garaging Address:",
    homeTimeZone: "Fuseau horaire",
    Ifta: "IFTA",
    insuranceSettings: "Paramètres d'assurance",
    invalidGaragingAddress: "Unable to generate coordinates from the garaging address provided. Please provide more specific address",
    lossControl: "Contrôle des pertes",
    maintainanceMileage: "Kilométrage d'entretien",
    maintainancePeriod: "periode de maintenance",
    maintainancePeriodMonth: "Période de maintenance (mois)",
    noOfTrucks: "Nombre de camions",
    otherLocationAddress: "Adress d'autre endroit",
    otherLocationContactPerson: "Personne-ressource d'autre endroit",
    otherLocationPhoneNumber: "Numero de telephone d'autre endroit",
    pageHeading: "Données sur l'entreprise",
    paymentInformation: "Information de paiement",
    radiusCompliance: "Conformité au rayon",
    skipcompanyCheckbox: "ignorer la recherche de remplissage de vehicule",
    underwriter: "Souscripteur",
    updateCardDetails: "Mettre a jour les details de la carte",
    updateCreditCardDetails: "Mettre a jour les details de la carte de credit",
    vehicleType: "Type de véhicule",
    website: "site web",
    noOfCameras: "Nombre initial de caméras",
    billingInformation: "Informations de facturation",
    noOfActiveTrucks: "Nombre de camions actifs",
  },
  paymentInformation: {
    listHeading: "Détails de facturation",
    listHeadingPayment: "DÉTAILS DU PAIEMENT",
    paymentId: "Identifiant du paiement",
    contractExpiry: "Date d'expiration du contrat",
    companyInfo: "Informations sur l'entreprise",
    contractHistory: "Histoire de contrat",
    startDate: "Date de debut du contrat",
    contractLength: "La duree du contrat",
    nextBilling: "Prochaine date de Facturation",
    paymentHistory: "Historique de facturation",
    createdDate: "Date de creation",
    paidDate: "Date de paiement",
    unitCount: "Nombre d'unites",
    cost: "Cout par unite",
    receipt: "Recu de paiement",
    start: "DATE DE DÉBUT",
    end: "DATE DE FIN",
    noOfDays: "Numero de jours",
    status: "Statut du paiement",
    company: "Nom d'etreprise",
    companyInfoHeading: "Informations sur l'entreprise",
    paymentHistoryHeading: "Historique des paiements",
    paymentHistoryText: "Historique des paiements",
  },
  suspended: {
    listHeading: "abonnement",
    buttonText: "Payer avec carte",
    title: "Biliing Details",
    description: "Vous avez un cotrat actif de:",
    to: "Till",
    payButtonText: "Ajouter les détails de la carte",
    expiredContract: "Votre contrat a expiré.",
    saveButtonText: "Enregistrer",
  },
  policies: {
    ACCIDENT_INVESTIGATION: "enquête sur un accident",
    ALLOW_USING_PHONES: "Autoriser l'utilisation du Bluetooth",
    chooseImage: "Veuillez choisir document.png ou .jpg",
    companyLogo: "Logo de l'entreprise",
    CUSTOM_POLICY: "Police personnalisée",
    customPolicies: "Polices personnalisées",
    DISTRACTION_FREE_DRIVING: "Conduite sans distraction",
    DRESS_CODE: "Code vestimentaire",
    DRIVER_SELECTION_MVR: "Sélection du conducteur et MVR",
    DRIVING_TRAINING: "Formation à la conduite",
    heading: "Les politiques et les procedures",
    INSPECTION: "Inspection",
    LOSS_CONTROL_MANUAL_POLICY: "Manuel de contrôle des pertes",
    mainInfo: "Informations principales",
    MIN_DRIVER_AGE: "Age minimum du conducteur autorise",
    MIN_HOURS: "Heures de formation à effectuer chaque année",
    MIN_YEARS_ON_SIMILAR_EQUIPMENT: "Nombre minimum d'années d'expérience sur un équipement similaire",
    NUMBER_OF_ACCIDENTS_ALLOWED: "Nombre maximal d'accidents",
    NUMBER_OF_CITATIONS_ALLOWED: "Nombre maximal autorisé de contraventions",
    PSP_USAGE: "Utilisation du PSP",
    SAFETY_PERSON_FULL_NAME: "Nom complet du responsable de la sécurité",
    selectPolicies: "Sélectionnez les politiques",
    TRAINING_DAYS: "Jours de formation",
  },
  potentialViolations: {
    heading: "Violations potentielles",
    pageHeading: "Gerer les infrations",
    violationType: "Type de violation",
  },
  dailyDocuments: {
    receipt: "Reçu",
    users: "Utilisateurs",
    documentType: "Type de document",
    cusName: "Nom du client/nom du travail",
    uploadNewDoc: "Telecharger nouveau document",
  },
  popup: {
    success: "Succes",
  },
  reportPage: {
    allDutyTimeTracker: "Rapport sur le suivi de toutes les heures de service",
    bayIndustriesPayroll: "Rapport sur la paie",
    billOfLading: "Rapport de connaissement",
    borderStates: "Document Rapport horaire",
    DailyFailedInspectionReport: "Echec du rapport d'inspection",
    DailyHocDriverViolation: "Rapport d'infractions HOS",
    DailyUnidentifiedDrivingReport: "Rapport de conduite non identifie",
    dailyUnsignedLogReport: "Rapport de journal non signe",
    driverPerf: "RAPPORT DE PERFORMANCE DU CONDUCTEUR",
    drivingEvents: "Rapport d'evenement de conduite",
    dutyStatus: "Statut de service",
    editedData: "Rapport de donnees edite",
    eldDisconn: "RAPPORT DE DÉCONNEXION DE L'ELD",
    hos: "Details d'infractions HOW",
    malFunc: "RAPPORT DE DYSFONCTIONNEMENT",
    MonthlyHOSDriverViolationsReport: "Rapport mensuel des infractions HOS de conducteur",
    MonthlyUnsignedLogReport: "Rapport mensuel de journaux pas signes",
    noOfRequestsPerDay: "No Of Requests Per Day",
    odoJump: "Rappor de saut d'odometre",
    pastDueServiceRequests: "Demandes de service en retard",
    pendingDriverDVIR: "Chauffeur en attente DVIR",
    pendingMechanic: "Mécanicien en attente",
    rejectedEdits: "Modification rejetees",
    unassigned: "RAPPORT DE CONDUITE NON ATTRIBUÉ",
    violation: "RAPPORT DE VIOLATION",
    dtc: "Rapport DTC",
  },
  graphTitles: {
    hardAcceleration: "Acceleration forte",
    hardDeceleration: "Deceleration forte",
    speeding: "Exces de vitesse",
    hoursExceeding: "Heures de conduite depasses",
    fuelEconomy: "Economie de carburant",
    nonBuckledSeatbelt: "Avertissment de ceinture de securite non bouclee",
    hardTurn: "Virage forte",
  },
  companies: {
    listHeading: "Gerer des entreprises]",
    company: "Entreprise",
    dot: "Point n°",
    activeTrucks: "Camions Actifs",
    payment: "Détails de facturation",
    contractLength: "La duree du contrat",
    contractExpiration: "Expiration du contrat",
    registrationDate: "Date d'inscription",
    status: "Statut",
    producerCode: "Code revendeur",
    producerName: "Nom du revendeur",
    companyName: "Nom d'etreprise",
    email: "Courriel",
    phone: "Téléphone",
    severity: "Gravite",
    fleetScore: "Score de flotte (sur 100)",
    fleetManager: "Gestionnaire de flotte",
    searchCompanies: "Chercher des entreprises",
    activeVehicles: "Vehicules actives",
    lossControl: "Contrôle des pertes",
    xDate: "Date X",
    alerts: "alertes",
    comapanyNumber: "Numéro de l'entreprise",
    policyHolderNumber: "Numéro du titulaire de la police",
    paymentStatus: "Statut du paiement",
  },
  defectDetails: {
    area: "Region",
    part: "Pièce",
    defectDetails: "DÉTAILS DU DÉFAUT",
    commentsByMechanic: "COMMENTAIRES DU MÉCANICIEN",
    fixStatus: "Regler statut",
    comments: "COMMENTAIRES DU PILOTE",
    status: "Etat de verification",
    viewPhoto: "Voir photo",
  },
  scoreCard: {
    heading: ":name Scorecard",
    fleet: "Flotte",
    policyHolderManagementScore: "Score de gestion du titulaire de la police",
    policyHolderManagement: "Gestion du titulaire de la police",
    address: "Adresse",
    dotNumber: "Numéro DOT",
    xDate: "Date X",
    date: "Date du rapport",
    fleetManagement: "Gestion de flotte",
    operatingTerritory: "Territoire d'exploitation",
    fleetManagementScore: "Score de gestion de flotte",
    vehicleInspectionScore: "Note d'inspection du véhicule",
    consistentEquipment: "Équipement cohérent",
    vehicleComposition: "Composition du véhicule",
    driverTurnOver: "Driver Turn Over",
    driverTenure: "Ancienneté du conducteur (années)",
    quickStats: "Statistiques rapides",
    radiusCompliance: "Conformité au rayon",
    radiusTable: {
      driverName: "NOM DU CONDUCTEUR",
      vehicle: "Véhicule",
      radius: "Rayon",
      radiusExperience: "Expérience du rayon",
      overage: "Dépassement",
      date: "Date de l'infraction",
    },
    radiusStats: "Rayon quotidien",
  },
  newScoreCard: {
    last30Days: "30 derniers jours",
    currentPolicyPeriod: "Current Policy time Period",
    heading: "Aperçu de la fiche de score",
    selectPeriod: "Sélectionner la période",
    unpoweredDays: "Jours sans alimentation",
    poweredDays: "Jours d'alimentation",
    driverBehavior: "Driver Behaviour",
    fleetScore: "Score de flotte",
    radiusViolation: "Violation du rayon",
    distractedDriving: "Conduite inattentive",
    speeding: "Exces de vitesse",
    contact: "Contact",
    totalVehicle: "Total des véhicules",
    accidentTooltipTitle: "Accident is graded based on the following events :",
    speedingTooltipTitle: "Speeding is graded based on the following events : ",
    distractedTooltipTitle: "Distracted Driving is graded based on the following events : ",
  },
  scorecard: {
    driverBehavior: "Comportement du conducteur",
    unpoweredDays: "Jours sans alimentation",
    unpoweredDaysDescription: "Based on the number of days trucks were powered. Higher powered days result in a higher score.<br/><br/><i>Method: 0.2 * Powered Days Score</i>",
    driverBehaviorDescription: "Calculated based on the number of driving events. The score represents safe driving behavior, with fewer events leading to a higher score.<br/><br/><i>Method: 0.6 * Driver Behavior Score</i>",
    radiusViolations: "Violations du rayon",
    radiusViolationsDesc: "Measures the days trucks violated the predefined radius. Fewer violation days result in a higher score.<br/><br/><i>Method: 0.2 * Radius Violation Score</i>",
    total: "Total",
    vehicle: "Véhicules",
    driverBehaviorDesc: "Calculated based on the number of driving events across all trucks.<br /><br /><i>Method: 100 - (Sum of Events of all trucks / (Total Working Days * Total Trucks)) * 100.</i><br /><br />The pie chart shows the number of trucks grouped by their individual performance percentages, indicating how many trucks fall within each defined range.",
    actualScore: "Score réel",
    distractedDriving: "Conduite inattentive",
    accident: "Accident",
    speeding: "Exces de vitesse",
    moreInfo: "Plus d'informations",
    unpoweredDaysGraphDesc: "Calculated based on the number of days trucks were powered.<br /><br /><i>Method: Sum of each truck's Powered Days / (Total Working Days * Total Trucks) * 100.</i><br /><br />The pie chart shows the number of trucks grouped by their individual performance percentages, indicating how many trucks fall within each defined range.",
    unpoweredDaysTotalDesc: "The cumulative number of unpowered days across all trucks in the fleet",
    radiusViolationGraphDesc: "Calculated based on the number of days trucks violated the predefined radius.<br /><br /><i>Method: 100 - (Sum of each truck's Violation Days / (Total Working Days * Total Trucks)) * 100.</i><br /><br />The pie chart shows the number of trucks grouped by their individual performance percentages, indicating how many trucks fall within each defined range.",
    radiusViolationTotalDesc: "The cumulative number of radius violation days across all trucks in the fleet",
    noDataText: "No Data Available !",
    excellent: "Excellent",
    good: "Bon",
    average: "Moyenne",
    belowAverage: "En dessous de la moyenne",
  },
  banner: {
    tellUs: "Donnez-nous plus d'informations sur votre flotte !",
    haveCameraQ: "Avez-vous des caméras ?",
    haveInsuranceQ: "Qui est votre assureur ?",
    yes: "Oui",
    no: "Non",
    cameraProviderQ: "Qui est votre fournisseur de caméras ?",
    policyRenewQ: "Quand votre police est-elle renouvelée ?",
    submit: "Soumettre",
    later: "Annuler",
    thankYou: "Merci pour votre réponse !",
    thankYouInfo: "This window will disappear in {{ count }} seconds",
    close: "OK",
    email: "ADRESSE E-MAIL",
    phone: "Numéro de téléphone",
    emailValidation: "Email must be a valid",
    cameraProviderPlaceholder: "Entrez votre fournisseur de caméras.",
    insuranceProviderPlaceholder: "Enter your Inusurance provider",
    emailPlaceholder: "",
    phoneNumberPlaceHolder: "000-000-0000",
  },
  fmcsa: {
    title: "Liste FMCSA",
    Reseller: "Revendeur",
    driver: "Conducteur",
    vehicle: "Véhicule",
    date: "Date",
    file: "Fichier",
    submissionId: "ID de soumission",
    response: "Réponse",
    message: "Messagerie",
    showMore: "Afficher plus",
    userId: "ID utilisateur",
    platform: "Plateforme",
  },
}
